const PromoteActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49H12.17C13.3994 11.449 14.5646 10.9315 15.4193 10.0469C16.274 9.16234 16.7512 7.98004 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
        fill="var(--adm-color-primary)"
      />
      <path
        d="M17.08 14.149C14.29 12.289 9.73999 12.289 6.92999 14.149C5.65999 14.999 4.95999 16.149 4.95999 17.379C4.95999 18.609 5.65999 19.749 6.91999 20.589C8.31999 21.529 10.16 21.999 12 21.999C13.84 21.999 15.68 21.529 17.08 20.589C18.34 19.739 19.04 18.599 19.04 17.359C19.03 16.129 18.34 14.989 17.08 14.149Z"
        fill="var(--adm-color-primary)"
      />
      <path
        d="M14 16.629H12.75V15.379C12.75 14.969 12.41 14.629 12 14.629C11.59 14.629 11.25 14.969 11.25 15.379V16.629H10C9.59 16.629 9.25 16.969 9.25 17.379C9.25 17.789 9.59 18.129 10 18.129H11.25V19.379C11.25 19.789 11.59 20.129 12 20.129C12.41 20.129 12.75 19.789 12.75 19.379V18.129H14C14.41 18.129 14.75 17.789 14.75 17.379C14.75 16.969 14.41 16.629 14 16.629Z"
        fill="white"
      />
    </svg>
  );
};

export default PromoteActive;
